// ** React Imports
import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const ComissionList    = lazy(() => import('../../views/comission/list'))
const Comission = [
  {
    path: 'comission/list',
    element: <ComissionList />
  }
]


export default Comission